import { create } from 'zustand'

interface UIState {
  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
  toggleSidebar: () => void
  // Mobile sessions drawer
  mobileSessionsOpen: boolean
  setMobileSessionsOpen: (open: boolean) => void
  toggleMobileSessions: () => void
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: false,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  // Mobile sessions drawer
  mobileSessionsOpen: false,
  setMobileSessionsOpen: (open) => set({ mobileSessionsOpen: open }),
  toggleMobileSessions: () => set((state) => ({ mobileSessionsOpen: !state.mobileSessionsOpen })),
}))
